module.exports = __webpack_public_path__ + "img/D2-h.759e1360.jpg";